import React from 'react';
import { Box, Image } from 'components';
import { styled } from 'themes';

const Icon = props => {
  const { src, ...rest } = props;
  return (
    <Container bg="white" {...rest}>
      <Image src={src} />
    </Container>
  );
};

const Container = styled(Box)`
  display: flex;
  justify-content: center;
  align-content: center;
  width: 50px;
  height: 50px;
  border-radius: 3px;
`;

export default Icon;
